import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private baseUrl = `${environment.Server_URL}/notifications`;
  constructor(private http: HttpClient) {}
  getAllNotifications(): Observable<any> {
    return this.http.get(this.baseUrl);
  }
  getNotificationById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }
  addNotification(data: FormData): Observable<any> {
    return this.http.post(this.baseUrl, data);
  }
  updateNotification(id: number, data: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/${id}?_method=PUT`, data); // Laravel method spoofing
  }
  deleteNotification(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
